export function normalizeTemplate(template) {
    return Object.assign(Object.assign({}, template), { translations: Object.keys(template.translations || {}).reduce((tr, locale) => (Object.assign(Object.assign({}, tr), { [locale]: Object.assign(Object.assign({}, template.translations[locale]), { isEnabled: !template.translations[locale].is_deactivated }) })), {}) });
}
